var _ellipse, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _path13, _path14, _path15, _path16, _circle, _path17, _path18, _path19, _ellipse2, _rect23, _ellipse3, _rect24, _path20, _path21, _path22, _path23, _path24, _circle2, _path25, _path26, _path27, _path28, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _circle3, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawHire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b225c2ac-b0fc-4c56-8095-6e63207963c3",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1068.58312,
    height: 648.29544,
    viewBox: "0 0 1068.58312 648.29544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hire") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 679.58312,
    cy: 613.29544,
    rx: 389,
    ry: 35,
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 555.15326,
    y: 125.85228,
    width: 422.23089,
    height: 285.97908,
    transform: "translate(1466.82897 411.83136) rotate(-180)",
    fill: "#3f3d56",
    opacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 759.70254,
    y: 26.20227,
    width: 125.02227,
    height: 136.25181,
    fill: "#f2f2f2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 627.77099,
    y: 152.05455,
    width: 120.53045,
    height: 8.235,
    transform: "translate(1310.36398 186.49182) rotate(-180)",
    fill: "#f2f2f2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 825.41098,
    y: 309.26818,
    width: 42.67227,
    height: 8.235,
    transform: "translate(1627.78578 500.91908) rotate(-180)",
    fill: "#f2f2f2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 826.90825,
    y: 324.24091,
    width: 122.02772,
    height: 8.235,
    transform: "translate(1710.13578 530.86454) rotate(-180)",
    fill: "#f2f2f2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 603.06599,
    y: 182.00001,
    width: 173.68363,
    height: 8.235,
    transform: "translate(1314.10716 246.38273) rotate(-180)",
    fill: "#f2f2f2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 603.06599,
    y: 205.20773,
    width: 173.68363,
    height: 8.235,
    transform: "translate(1314.10716 292.79818) rotate(-180)",
    fill: "#f2f2f2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 603.06599,
    y: 228.41546,
    width: 173.68363,
    height: 8.235,
    transform: "translate(1314.10716 339.21364) rotate(-180)",
    fill: "#f2f2f2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 603.06599,
    y: 251.62319,
    width: 173.68363,
    height: 8.235,
    transform: "translate(1314.10716 385.62909) rotate(-180)",
    fill: "#f2f2f2"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 603.06599,
    y: 274.83091,
    width: 173.68363,
    height: 8.235,
    transform: "translate(1314.10716 432.04454) rotate(-180)",
    fill: "#f2f2f2"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 603.06599,
    y: 298.03864,
    width: 173.68363,
    height: 8.235,
    transform: "translate(1314.10716 478.45999) rotate(-180)",
    fill: "#f2f2f2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 603.06599,
    y: 321.24636,
    width: 173.68363,
    height: 8.235,
    transform: "translate(1314.10716 524.87545) rotate(-180)",
    fill: "#f2f2f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M844.18655,229.85707a22.11528,22.11528,0,0,1,6.05387-3.03595,154.36693,154.36693,0,0,1,42.65465-9.28523c12.68323-.89939,26.4296.16885,36.33587,8.14a12.49385,12.49385,0,0,1,3.68578,4.29411c1.24628,2.6894.86859,5.81555.46513,8.7521a9.88954,9.88954,0,0,1-.84872,3.29481c-1.33305,2.53813-4.61508,3.42726-7.46577,3.12291s-5.52564-1.5105-8.33747-2.06973a37.26883,37.26883,0,0,0-5.26591-.53628l-17.63515-.95472c-10.96618-.59369-22.07685-1.17749-32.83376,1.03571a32.70556,32.70556,0,0,0-9.48634,3.26894c-2.45692,1.37942-4.11135,3.35879-6.39109.81094C841.11247,242.2185,838.89552,233.99153,844.18655,229.85707Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M871.514,237.65562s23.72-10.63309,32.7172,1.63586-4.90758,7.36138-4.90758,7.36138l-15.54067,4.90758-17.17653-3.27172Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M872.74088,229.88529s3.27172,15.54067.81793,19.63032,13.90481,9.81516,13.90481,9.81516l15.54067-6.54344s-4.08965-25.35583,0-30.26341Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#ffb9b9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M872.74088,229.88529s3.27172,15.54067.81793,19.63032,13.90481,9.81516,13.90481,9.81516l15.54067-6.54344s-4.08965-25.35583,0-30.26341Z",
    transform: "translate(-65.70844 -125.85228)",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M910.36566,214.34462a24.558,24.558,0,0,1-24.5379,24.5379,23.94747,23.94747,0,0,1-4.35958-.39259,24.5369,24.5369,0,1,1,28.89748-24.14531Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#ffb9b9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M925.18176,289.055h-78.255l1.77426-7.7035,7.681-33.4715,8.87881-5.99658.0075-.00749,4.16995-2.82238,2.07374-1.39994s1.22768.56147,2.64262,1.3251c.41169.232.831.47164,1.25025.72615.0075-.0074.0075,0,.0075,0a14.6478,14.6478,0,0,1,1.93145,1.34009c.11231.10482.20964.19465.307.292,1.55713,1.55713,6.10131,9.8221,13.61765,5.59229a11.4484,11.4484,0,0,0,1.10048-.68869,54.46,54.46,0,0,0,5.59229-4.43945c1.5797-1.44491,2.60533-2.56037,3.4438-3.33149a5.43774,5.43774,0,0,1,1.27264-.94329,2.41956,2.41956,0,0,1,1.14544-.2769c2.45555,0,5.72708,4.90352,5.72708,4.90352l.09733.28448.00749.02248,10.32373,30.99348Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M846.92678,289.055h23.7168a57.721,57.721,0,0,0-.42672-8.20505c-.72618-5.47253-2.50793-10.74293-3.63089-16.14809a67.93388,67.93388,0,0,1-1.42989-14.40376c.00749-.66629.02246-1.34006.08235-2.01383a9.22,9.22,0,0,1,1.29514-4.372c.56148-.86093,1.33257-1.59459,1.93148-2.41809a5.54845,5.54845,0,0,0,.54651-.86094v-.00748a4.97634,4.97634,0,0,0,.20213-.45667,3.69647,3.69647,0,0,0,.22459-1.11547c.13475-2.4705-2.10367-4.85116-4.52176-5.86931a16.90557,16.90557,0,0,0-10.59321-.42672,50.42212,50.42212,0,0,0-9.95686,4.07258c-1.07055.52405-2.13361,1.06307-3.15925,1.662a15.68362,15.68362,0,0,0-3.3464,2.54537c-2.54536,2.62771-3.66083,6.28854-4.5592,9.82959a20.78169,20.78169,0,0,0-.86093,8.38473c.00749.08984.03.18716.04492.277.89088,4.664,4.69395,8.16762,6.72275,12.46479,2.35072,4.98592,2.19351,10.79534,1.25771,16.23044-.04491.277-.09732.554-.14972.831h6.61045Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M943.47089,259.10206a185.34934,185.34934,0,0,0-6.46064,29.95294H903.20171q-1.325-3.61588-2.64261-7.23934a54.27606,54.27606,0,0,1-1.80424-5.56981,26.65666,26.65666,0,0,1-.75613-6.70785c0-.539.02248-1.08548.06744-1.62448a.02281.02281,0,0,0,0-.03,26.78892,26.78892,0,0,1,1.95384-8.28745,30.91223,30.91223,0,0,1,1.7219-3.49607c1.57221-2.84486,3.47368-5.52494,5.16561-8.30985a38.1382,38.1382,0,0,0,2.74752-5.33029.02752.02752,0,0,1,.0075-.02248,19.13231,19.13231,0,0,0,1.54964-7.44889c-.05237-3.30151-5.63717-9.05857.43417-8.50459,8.28746.74864,15.407,5.51754,21.89761,10.95264,1.7294,1.45231,3.42132,2.95708,5.07578,4.43937,2.56037,2.30585,5.26294,4.82117,6.034,8.18254a8.724,8.724,0,0,1,.21714,1.63207A22.405,22.405,0,0,1,943.47089,259.10206Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M892.79728,250.07328a18.28084,18.28084,0,0,0-3.83854-6.18912,14.24073,14.24073,0,0,0-5.8635-2.97059,32.06549,32.06549,0,0,0-8.60156-1.2328c-3.464-.02158-7.48055.9076-8.95156,4.04385-1.16813,2.49048-.26255,5.43958.91357,7.92629a7.77142,7.77142,0,0,0,2.42482,3.27562c1.49382,1.0093,3.42581.97731,5.19666,1.31537a23.96891,23.96891,0,0,1,7.68062,3.48045l6.0672,3.66739,10.42129,6.29927c-.27461-.166-.177-7.3125-.49707-8.48373C896.71813,257.43232,894.39693,253.64621,892.79728,250.07328Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#ffb9b9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M909.74842,201.55677a6.22837,6.22837,0,0,0-2.70136-3.526,14.2944,14.2944,0,0,0-.57036-4.65328c-1.486-4.39313-5.00628-4.14132-8.32777-6.0836-1.44106-.84269-1.352-1.58749-2.10224-2.97159a11.02878,11.02878,0,0,0-4.24965-4.33592c-2.13094-1.35769-4.38035-2.75592-6.90124-2.92775-5.29767-.36109-9.35946,4.62177-14.4229,6.221-2.23184.70486-4.63.73391-6.87363,1.40028s-4.482,2.25749-4.81642,4.57394c-.15436,1.06944.118,2.16654-.03859,3.23568-.31127,2.125-2.17557,3.61319-3.42359,5.361-2.75981,3.865-2.44415,9.32517-.23713,13.53044a19.01869,19.01869,0,0,0,1.59143,2.49038,15.31941,15.31941,0,0,0,1.68029,5.68892c2.207,4.20527,6.00478,7.34769,9.972,9.95844a23.53741,23.53741,0,0,1-.58844-4.24651,2.92938,2.92938,0,0,1,.18057-1.407c.44182-.92357,1.60925-1.16919,2.49937-1.675,1.84364-1.04768,2.56662-3.36623,2.61993-5.48609s-.39593-4.24321-.17383-6.352a3.47082,3.47082,0,0,1,1.18816-2.55314,4.104,4.104,0,0,1,2.24007-.53407c3.77744-.15411,7.72426-.2235,11.05619-2.00983a16.3852,16.3852,0,0,1,3.44125-1.7408c2.83161-.7384,5.72566,1.24627,7.35758,3.6753s2.44555,5.31959,3.95121,7.82884,4.10683,4.74693,7.018,4.44964a1.165,1.165,0,0,0,.8694-.3866,1.30319,1.30319,0,0,0,.16015-.7407l.16265-11.12792A16.81994,16.81994,0,0,0,909.74842,201.55677Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#2f2e41"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M845.03271,275.87153q.79725,6.56925.96577,13.18347H825.411V271.754c.10482-.41928.21708-.831.35183-1.24276,1.28768-3.96781,3.99029-7.29172,6.33344-10.74292.1124-.17226.23212-.34443.34443-.5166a28.107,28.107,0,0,0,2.56037-4.619c.33685-.7936.87585-4.63411,1.44482-4.96346,2.44056-1.41494,4.42447,4.634,4.76132,5.98159,1.19779,4.79879,2.2385,9.64244,3.02452,14.53106Q844.69215,273.023,845.03271,275.87153Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M949.07067,289.055H901.80935c-.40429-.95078-.80109-1.90156-1.22037-2.84485a83.17176,83.17176,0,0,0-11.33428-18.58861,4.91814,4.91814,0,0,1-1.4-2.7775,2.35088,2.35088,0,0,1,.30706-1.25017c.71866-1.34009,2.62022-2.12619,4.16237-2.76242a14.3431,14.3431,0,0,0,4.327-2.72514,9.27856,9.27856,0,0,0,2.50052-3.69073,8.09876,8.09876,0,0,0,.31436-1.27264c.21714.28439.44177.57646.6589.86086.5315.70376,1.0705,1.4,1.617,2.09622,5.24045,6.73023,10.99751,13.36314,18.23686,17.35334a30.68188,30.68188,0,0,0,5.95912,2.538,1.56384,1.56384,0,0,0,1.25765,0,1.522,1.522,0,0,0,.54649-1.00323c.64391-2.69508.86845-5.47258,1.34009-8.205a46.73545,46.73545,0,0,1,4.93358-14.2091c1.34-2.493,5.697-11.60386,8.45954-5.86188q1.19025,2.48167,2.39569,4.97845c.50153,1.0556,1.01055,2.10362,1.51966,3.15931a19.64791,19.64791,0,0,1,2.463,11.00492Q948.96591,277.46608,949.07067,289.055Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M846.92678,289.055h4.09505l-2.32078-7.70347-3.3464-11.10227a36.21553,36.21553,0,0,1-.32191,5.62226,37.43549,37.43549,0,0,1-3.26406,11.10976c-.32191.68126-.66629,1.37-.94328,2.07372h6.10138Z",
    transform: "translate(-65.70844 -125.85228)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M930.34009,265.38047c-.57663,1.55069-.053,3.26563.39146,4.85926a48.9604,48.9604,0,0,1,1.78437,14.20657.51708.51708,0,0,1-.60472.61978c-1.88793.11565-4.04933.12788-5.33021-1.26388Z",
    transform: "translate(-65.70844 -125.85228)",
    opacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 2.9435,
    width: 422.23089,
    height: 285.97908,
    fill: "#3f3d56",
    opacity: 0.3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 26.95091,
    y: 29.14577,
    width: 125.02227,
    height: 136.25181,
    fill: "#f2f2f2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 229.08272,
    y: 29.14577,
    width: 120.53045,
    height: 8.235,
    fill: "#f2f2f2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 28.44818,
    y: 186.3594,
    width: 42.67227,
    height: 8.235,
    fill: "#f2f2f2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 28.44818,
    y: 201.33213,
    width: 122.02772,
    height: 8.235,
    fill: "#f2f2f2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 200.63454,
    y: 59.09123,
    width: 173.68363,
    height: 8.235,
    fill: "#f2f2f2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 200.63454,
    y: 82.29895,
    width: 173.68363,
    height: 8.235,
    fill: "#f2f2f2"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 200.63454,
    y: 105.50668,
    width: 173.68363,
    height: 8.235,
    fill: "#f2f2f2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 200.63454,
    y: 128.71441,
    width: 173.68363,
    height: 8.235,
    fill: "#f2f2f2"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 200.63454,
    y: 151.92213,
    width: 173.68363,
    height: 8.235,
    fill: "#f2f2f2"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 200.63454,
    y: 175.12986,
    width: 173.68363,
    height: 8.235,
    fill: "#f2f2f2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 200.63454,
    y: 198.33758,
    width: 173.68363,
    height: 8.235,
    fill: "#f2f2f2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M214.28282,291.9985H198.02991q-1.87532-5.04205-3.33144-10.21141a20.39947,20.39947,0,0,0-5.30036-10.80286,20.03741,20.03741,0,0,1-2.28333-3.09927,14.55663,14.55663,0,0,1-1.43737-8.82645,22.92584,22.92584,0,0,1,.41924-2.50052c.71121-3.1966,1.90152-6.266,2.89722-9.38034a3.5579,3.5579,0,0,1,2.90471-2.40318,5.76176,5.76176,0,0,1,3.17421.36682,3.94235,3.94235,0,0,1,.63637.32945c1.77426,1.07059,2.69507,3.25655,3.43621,5.25544q5.087,13.65516,10.1665,27.31024.9882,2.65015,1.97641,5.3153c.97322,2.60524,1.93894,5.21048,2.76247,7.86817C214.13309,291.482,214.20793,291.73641,214.28282,291.9985Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#d0cde1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M146.62216,172.17984c-4.041,1.3647-7.702,4.55664-8.52949,8.74082-.38359,1.93956-.14841,3.95583-.47121,5.90643-.74864,4.52385-4.29972,7.97875-7.575,11.18785s-6.6576,6.938-6.89664,11.51711c-.26176,5.01427,3.37475,9.71183,2.74548,14.69335-.73108,5.78749-6.84387,9.53769-8.355,15.17206-1.009,3.76233.22743,7.81509,2.26168,11.137,3.87649,6.33022,10.50258,10.6278,17.55887,12.93166s14.5714,2.78854,21.99385,2.86631c9.0377.0947,18.85027-.6812,25.64075-6.646a20.54135,20.54135,0,0,0,6.81933-13.37276c.64509-6.90931-2.23867-14.04848-.24952-20.69665,1.25186-4.184,4.39123-8.00514,3.92272-12.34719-.45809-4.24544-4.166-7.25469-6.70977-10.68442-2.375-3.20224-3.81621-6.98392-5.22866-10.71221l-4.83278-12.75655c-.95-2.50772-1.99329-5.14517-4.11049-6.79108-3.96361-3.08123-10.33693-2.47584-14.97163-1.84034C155.33507,171.07481,150.757,170.78345,146.62216,172.17984Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M150.36065,214.22007s.473,14.191-.94606,15.61008S155.091,240.7099,155.091,240.7099l12.77189-.473,6.62245-5.20336-5.67639-7.56853s-2.36516-12.29885-.473-15.137S150.36065,214.22007,150.36065,214.22007Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#a0616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M150.36065,214.22007s.473,14.191-.94606,15.61008S155.091,240.7099,155.091,240.7099l12.77189-.473,6.62245-5.20336-5.67639-7.56853s-2.36516-12.29885-.473-15.137S150.36065,214.22007,150.36065,214.22007Z",
    transform: "translate(-65.70844 -125.85228)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.45725,
    cy: 76.77848,
    r: 17.02918,
    fill: "#a0616a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M166.89413,291.9985H180.699c.51656-.93579,1.00317-1.909,1.56465-2.79241v-.00749a7.64253,7.64253,0,0,1,2.51542-2.6352,9.91145,9.91145,0,0,0,1.8641-1.11546,4.80868,4.80868,0,0,0,1.13793-2.12613,32.94733,32.94733,0,0,0,1.55716-9.17828c.02246-1.04809,0-2.11116.0599-3.15925a13.28186,13.28186,0,0,1,.31442-2.43307,19.16027,19.16027,0,0,1,2.04378-4.62657q2.80738-5.10944,5.62975-10.21888a7.14253,7.14253,0,0,0,.3818-2.99455,7.38149,7.38149,0,0,0-1.21279-3.8405c-.262-.47164-.54651-.94329-.846-1.39995a31.093,31.093,0,0,0-4.01269-5.12068,32.46284,32.46284,0,0,0-11.42419-7.73341,6.62994,6.62994,0,0,1-1.53471-.74864,6.36983,6.36983,0,0,1-1.40743-1.68443c-1.49727-2.25339-3.32395-4.79127-6.02652-4.649a3.7052,3.7052,0,0,0-2.8598-.19464,3.91,3.91,0,0,0-.41923.13475,26.6057,26.6057,0,0,0-3.002,1.56465,13.93548,13.93548,0,0,1-8.08528,1.46733,2.73852,2.73852,0,0,1-.94328-.23957,4.83352,4.83352,0,0,1-.86842-.70371,4.99165,4.99165,0,0,0-4.96345-.79356,4.507,4.507,0,0,0-1.9764,1.39246c-.4941.62137-.83848,1.37-1.385,1.95394-1.41492,1.51225-3.75067,1.57214-5.81691,1.56465a53.75861,53.75861,0,0,0-12.77922,1.17536,24.29285,24.29285,0,0,0-10.06167,4.86614l-.00749.00749c-.40426.34437-.77858.69623-1.1529,1.07055a8.54573,8.54573,0,0,0-1.99137,2.84481c-.569,1.46733-.4941,3.12182-1.01066,4.6116-.569,1.66946-1.83416,3.032-2.34323,4.70893-.38929,1.27268-.33689,2.68011-.98071,3.833.02994.02246.0524.04492.08235.06738,2.725,2.39564,5.05329,5.53991,7.78581,7.91309a15.71294,15.71294,0,0,1,3.9528,4.417,7.29642,7.29642,0,0,1,.48662,1.19782,18.4192,18.4192,0,0,1,.40426,4.35706c.34437,6.99975,4.14,13.34819,8.38473,18.918.08235.1123.1647.22459.25453.3294Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#d0cde1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122.47755,267.19618q-.9658,6.704-1.94649,13.40061a58.3837,58.3837,0,0,1-1.33254,7.09706c-.38931,1.44481-.89088,2.85984-1.24277,4.30465H98.46128a18.67675,18.67675,0,0,1,.18716-2.41808,39.97789,39.97789,0,0,1,2.43307-8.39218q3.40259-9.18584,6.79763-18.38655c.96572-2.61274,1.7967-5.34528,2.85979-7.93562.18716-.47905.38926-.95819.6064-1.42234,1.1304-2.48552,4.26719-1.46729,6.588-1.093a6.25592,6.25592,0,0,1,1.84161.524,4.75194,4.75194,0,0,1,1.7294,1.632c2.201,3.25664,1.72185,7.5613,1.15288,11.45417Q122.56736,266.5786,122.47755,267.19618Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#d0cde1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M182.26363,289.20611c.02993.10472.35184,1.22018.88339,2.79239H166.89411c8.05533-1.385,15.36952-2.79989,15.36952-2.79989Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#2f2e41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.87635,
    cy: 66.84479,
    rx: 18.44828,
    ry: 9.93369,
    fill: "#2f2e41"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 270.48911,
    y: 108.22219,
    width: 422.23089,
    height: 285.97908,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 631.33182,
    cy: 369.49627,
    rx: 49.41,
    ry: 5.24045,
    opacity: 0.1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 297.44002,
    y: 134.42446,
    width: 125.02227,
    height: 136.25181,
    fill: "#f2f2f2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M403.40684,322.83441a1.83513,1.83513,0,0,0,2.1511-.8888c1.72919-2.72448-1.45447-6.23754-.76511-9.38995.55228-2.52554,3.42213-4.02453,4.0089-6.54228.57015-2.44641-1.18668-5.20394.00076-7.41753.93029-1.73423,3.25407-2.1906,5.19847-1.88679s3.79,1.15857,5.75431,1.27834c2.61753.15958,5.11266-.99268,7.67215-1.5636s5.68145-.34739,7.18715,1.79965c1.93334,2.75683-.02783,6.59563.64535,9.89483.53455,2.61979,2.72773,4.789,2.77485,7.46241.01675.95019-2.48115.18473-2.34838,1.12574s-1.04784.11246-.1041.00067a1.86922,1.86922,0,0,0,1.42025-1.68928c.11221-.78377,1.58513-1.045,1.56813-1.83663-.03982-1.85517,3.31424-.60431,3.8666-2.37579a17.96415,17.96415,0,0,0-.73414-12.53192,25.09888,25.09888,0,0,1-2.13953-5.09654c-.49273-2.4598.28256-5.10043-.53011-7.47381-1.09519-3.19848-4.7192-4.829-8.08373-5.16012s-6.78359.2616-10.12892-.22672c-2.99685-.43746-5.89813-1.73628-8.92089-1.54809-3.627.2258-6.78325,2.56276-9.29746,5.18669s-4.647,5.64189-7.5024,7.88976a14.71416,14.71416,0,0,0-2.4056,2.07095c-1.45435,1.77231-1.60186,4.29707-1.19728,6.55373s1.28491,4.40927,1.65662,6.67158c.34932,2.126.24155,4.29812.392,6.44742a11.33271,11.33271,0,0,0,1.891,6.086,5.74384,5.74384,0,0,0,4.46952,2.33505c.60522.014,1.11638-.52987,1.72723-.38806C402.39715,321.7986,402.72914,322.52369,403.40684,322.83441Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M375.9127,397.27719c.54654-7.49386.95828-13.09364.95828-13.09364l3.53354-9.313,11.34186,22.40668Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#575a89"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M375.9127,397.27719c.54654-7.49386.95828-13.09364.95828-13.09364l3.53354-9.313,11.34186,22.40668Z",
    transform: "translate(-65.70844 -125.85228)",
    opacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M402.19661,323.59667s10.57572,26.92,4.48667,32.04763,33.97049-8.65286,33.97049-8.65286l-.96143-3.52523s-13.13953-5.12763-6.73-19.86954S402.19661,323.59667,402.19661,323.59667Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#a0616a"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M402.19661,323.59667s10.57572,26.92,4.48667,32.04763,33.97049-8.65286,33.97049-8.65286l-.96143-3.52523s-13.13953-5.12763-6.73-19.86954S402.19661,323.59667,402.19661,323.59667Z",
    transform: "translate(-65.70844 -125.85228)",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 351.55056,
    cy: 186.20725,
    r: 22.43334,
    fill: "#a0616a"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M471.73815,360.45177s-.08983,1.78175-.24706,4.89606c-.32191,6.341-.89833,18.22183-1.47479,31.92936H383.05472a43.11613,43.11613,0,0,1-5.53243-9.90449,10.68812,10.68812,0,0,1-.65131-3.18915c-.47914-8.49705,7.13448-20.35543,12.50968-21.48587,6.08642-1.28768,17.62293-13.46052,17.62293-13.46052a2.7449,2.7449,0,0,0,1.4673,2.216v.0075a5.96417,5.96417,0,0,0,3.017.6588c3.75817,0,20.288-7.62861,25.59588-10.12158,1.04062-.48658,1.647-.77856,1.647-.77856a124.40014,124.40014,0,0,0,18.91052,6.41582A20.11224,20.11224,0,0,1,471.73815,360.45177Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#575a89"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M399.56113,320.59108a1.83513,1.83513,0,0,0,2.15109-.88881c1.72919-2.72447-1.45447-6.23754-.7651-9.38994.55228-2.52555,3.42212-4.02453,4.00889-6.54228.57015-2.44641-1.18667-5.204.00076-7.41753.9303-1.73424,3.25408-2.1906,5.19848-1.88679s3.79,1.15857,5.75431,1.27833c2.61752.15959,5.11265-.99268,7.67214-1.56359s5.68145-.34739,7.18715,1.79965c1.93335,2.75683-.02783,6.59562.64536,9.89483.53455,2.61979,6.625,4.45859,7.17735,2.68711a17.96412,17.96412,0,0,0-.73415-12.53191,25.09991,25.09991,0,0,1-2.13953-5.09654c-.49273-2.4598.28256-5.10043-.53011-7.47382-1.09519-3.19847-4.7192-4.829-8.08373-5.16012s-6.78359.26161-10.12892-.22672c-2.99685-.43745-5.89813-1.73627-8.92089-1.54808-3.627.2258-6.78325,2.56275-9.29746,5.18669s-4.647,5.64188-7.5024,7.88976a14.71445,14.71445,0,0,0-2.40559,2.07094c-1.45435,1.77231-1.60187,4.29707-1.19729,6.55374s1.28492,4.40926,1.65662,6.67157c.34932,2.12605.24156,4.29813.392,6.44742a11.33267,11.33267,0,0,0,1.891,6.086,5.74382,5.74382,0,0,0,4.46952,2.33506c.60521.014,1.11638-.52987,1.72722-.38806C398.55143,319.55527,398.88343,320.28036,399.56113,320.59108Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M482.85543,397.27719H457.47664c-1.9315-14.16423-3.5261-28.97224-3.5261-28.97224l5.12819-2.2459,10.421-5.60728s.76362,1.81168,1.99135,4.89606C474.11132,371.94332,478.86518,384.35572,482.85543,397.27719Z",
    transform: "translate(-65.70844 -125.85228)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M485.09384,397.27719H456.451c-4.24476-15.49678-8.42965-32.3411-8.42965-32.3411l10.90014-8.01042,12.81665,3.5261S479.2395,378.30672,485.09384,397.27719Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#575a89"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 499.57183,
    y: 134.42446,
    width: 120.53045,
    height: 8.235,
    fill: "#6c63ff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 298.93729,
    y: 291.63809,
    width: 42.67227,
    height: 8.235,
    fill: "#6c63ff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 298.93729,
    y: 306.61081,
    width: 122.02772,
    height: 8.235,
    fill: "#6c63ff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 471.12365,
    y: 164.36991,
    width: 173.68363,
    height: 8.235,
    fill: "#f2f2f2"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 471.12365,
    y: 187.57764,
    width: 173.68363,
    height: 8.235,
    fill: "#f2f2f2"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 471.12365,
    y: 210.78536,
    width: 173.68363,
    height: 8.235,
    fill: "#f2f2f2"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 471.12365,
    y: 233.99309,
    width: 173.68363,
    height: 8.235,
    fill: "#f2f2f2"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 471.12365,
    y: 257.20082,
    width: 173.68363,
    height: 8.235,
    fill: "#f2f2f2"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 471.12365,
    y: 280.40854,
    width: 173.68363,
    height: 8.235,
    fill: "#f2f2f2"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 471.12365,
    y: 303.61627,
    width: 173.68363,
    height: 8.235,
    fill: "#f2f2f2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M743.99295,430.58113l-47.47823,47.4783L676.5594,458.10392a6.8215,6.8215,0,0,0-9.64706-.00005l-.71688-1.07224c-2.664,2.664-1.94712,8.05537.71686,10.71934l25.8918,25.89174a5.2049,5.2049,0,0,0,7.35891.00191L753.6351,440.2283c2.66569-2.66292,3.63268-7.546.96834-10.21022h0C751.94013,427.35484,746.65622,427.91785,743.99295,430.58113Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#57b894"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M743.99295,430.58113l-47.47823,47.4783L676.5594,458.10392a6.8215,6.8215,0,0,0-9.64706-.00005l-.71688-1.07224c-2.664,2.664-1.94712,8.05537.71686,10.71934l25.8918,25.89174a5.2049,5.2049,0,0,0,7.35891.00191L753.6351,440.2283c2.66569-2.66292,3.63268-7.546.96834-10.21022h0C751.94013,427.35484,746.65622,427.91785,743.99295,430.58113Z",
    transform: "translate(-65.70844 -125.85228)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M743.99295,428.47617l-47.47823,47.47831L676.5594,455.999a6.8215,6.8215,0,0,0-9.64706,0h0a6.82151,6.82151,0,0,0,0,9.64709l25.8918,25.89173a5.20489,5.20489,0,0,0,7.35891.00192l53.47207-53.41632a6.8198,6.8198,0,0,0,.00245-9.64723h0A6.8198,6.8198,0,0,0,743.99295,428.47617Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#57b894"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.29156,703.47131c0,53.53346-74.61929,36.97507-165.98307,36.97507S762.434,757.00477,762.434,703.47131s74.60908-65.17655,165.97286-65.17655S1093.29156,649.93784,1093.29156,703.47131Z",
    transform: "translate(-65.70844 -125.85228)",
    opacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.29156,693.47131c0,53.53346-74.61929,36.97507-165.98307,36.97507S762.434,747.00477,762.434,693.47131s74.60908-65.17655,165.97286-65.17655S1093.29156,639.93784,1093.29156,693.47131Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#3f3d56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M781.36266,525.76176l-3.381,3.926S736.87,533.548,738.53849,540.22187s49.49807-8.89853,49.49807-8.89853Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#ffc1c7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M855.88784,522.42481s-43.93648,15.57243-67.85128,8.89853l11.12316,22.24633s56.72812-1.66848,66.739-11.67932S855.88784,522.42481,855.88784,522.42481Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#6c63ff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M855.88784,522.42481s-43.93648,15.57243-67.85128,8.89853l11.12316,22.24633s56.72812-1.66848,66.739-11.67932S855.88784,522.42481,855.88784,522.42481Z",
    transform: "translate(-65.70844 -125.85228)",
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 760.42495,
    cy: 247.80025,
    r: 29.47638,
    fill: "#ffc1c7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M851.26749,401.3255a22.99269,22.99269,0,0,0,3.81885,5.29338A48.21427,48.21427,0,0,0,869.29483,417.251a484.15339,484.15339,0,0,1-50.62433,7.52783c1.79459-6.31905-.5676-13.07787-3.742-18.82891s-7.221-11.11128-9.20775-17.37259l19.92341.53554c3.61489.09716,7.24153.20547,10.85577.02849,2.70133-.13227,7.20168-1.75057,9.72308-1.15452C851.55359,389.24693,848.94049,396.59764,851.26749,401.3255Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#ffc1c7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M918.17755,539.66572l16.68474,20.02169S962.6702,624.7579,902.049,631.4318s-105.67-5.00542-105.67-5.00542-24.471-11.67932-25.02711-2.7808-2.78079,33.92565-16.12859,58.3966l-11.67932,26.69559s-6.11774,6.11774-4.44926,14.46011-37.26259,11.12316-36.70643,0c0,0,5.56158-9.45469,5.56158-15.01627s8.89853-18.90937,8.89853-18.90937l16.12858-80.08677s-1.11232-41.15569,36.70643-33.36948,91.76609-1.66847,91.76609-1.66847l12.23547-42.82418Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#2f2e41"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M918.17755,539.66572l16.68474,20.02169S962.6702,624.7579,902.049,631.4318s-105.67-5.00542-105.67-5.00542-24.471-11.67932-25.02711-2.7808-2.78079,33.92565-16.12859,58.3966l-11.67932,26.69559s-6.11774,6.11774-4.44926,14.46011-37.26259,11.12316-36.70643,0c0,0,5.56158-9.45469,5.56158-15.01627s8.89853-18.90937,8.89853-18.90937l16.12858-80.08677s-1.11232-41.15569,36.70643-33.36948,91.76609-1.66847,91.76609-1.66847l12.23547-42.82418Z",
    transform: "translate(-65.70844 -125.85228)",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M855.60977,538.20087s50.88846-19.113,79.25252,21.48654c0,0,7.23006,62.84586-21.69016,65.62665s-66.739,2.22463-75.6375-7.23006-65.0705-36.15027-65.0705-36.15027-27.96145-14.26237-33.44625,4.27005-6.041,22.98169-6.041,22.98169-28.92022,21.134-40.59954,25.02712c0,0-7.78621,11.12316-12.23548,11.12316s-31.701,6.11774-28.92022-14.46011l45.04881-41.1557,45.0488-43.93649s12.79164-18.90937,45.605-8.89853a678.45343,678.45343,0,0,0,66.18281,16.12859Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#2f2e41"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M737.42617,722.08556s10.567,26.69559,1.66848,30.03254-27.80791,1.11232-27.80791,1.11232-22.24632-2.78079-27.8079-2.22464-28.36406-3.8931-25.02711-12.79163,20.57785-6.6739,20.57785-6.6739L694.602,724.3102s1.66848-5.56158,5.56158-3.337S715.17985,731.54025,737.42617,722.08556Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#cbceda"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M679.58573,643.11112s11.67932,26.13943-7.23005,23.91479-33.36949-6.11773-38.93107-6.67389c-5.34975-.535-20.47692-5.70136-18.15644-15.99414a9.15487,9.15487,0,0,0,.15083-2.02017c0-1.38171,1.877-4.093,16.8933-3.67586,0,0,11.12316,0,15.57242-7.78621C647.88472,630.87564,664.56947,652.00965,679.58573,643.11112Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#cbceda"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M805.83362,420.64789s40.04338-25.02712,73.41286,0,55.61581,139.03952,55.61581,139.03952l-77.306-17.2409s-3.337-13.3478-7.78621-15.57243-5.00543-11.67932-5.00543-11.67932-23.91479-7.23006-22.24632-35.038S805.83362,420.64789,805.83362,420.64789Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#6c63ff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M826.41147,421.7602H805.83362s-12.23548,13.904-13.904,48.94191L785.25577,498.51s-13.904,33.36948-5.56158,38.93106,24.47095,5.00543,27.8079-6.11774,26.13943-75.63749,26.13943-75.63749Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#6c63ff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M820.51385,335.29144a29.79589,29.79589,0,0,1,30.82134,5.05329c10.681,9.532,12.836,25.08181,15.53612,39.14068s8.132,29.71508,21.38218,35.135a55.70857,55.70857,0,0,1-17.95077-.52231l20.02344,17.9441-33.73052-10.9944c-10.58623-3.45056-21.70429-6.94445-32.66682-4.99574-18.1608,3.22829-30.80421,20.30087-48.24735,26.29865l1.93836-9.45865-11.70272-.0897a22.92077,22.92077,0,0,0,6.70506-7.85558,6.489,6.489,0,0,0-4.47671-2.34231c-4.87825-30.42846,13.1907-60.50728,36.73817-80.387,4.63166-3.91025,9.75679-7.666,15.73889-8.64411s12.96546,1.69677,15.04569,7.39018",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#2f2e41"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M310.196,614.15948c0,64.01613,40.16035,115.81717,89.79084,115.81717",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#3f3d56"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M399.98684,729.97665c0-64.73541,44.81662-117.11848,100.20136-117.11848",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#6c63ff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M342.72891,619.96265c0,60.80852,25.6095,110.014,57.25793,110.014",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#6c63ff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M399.98684,729.97665c0-82.71747,51.801-149.65139,115.81716-149.65139",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#3f3d56"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M381.09716,730.79318s12.73382-.39219,16.57147-3.12493,19.58782-5.99579,20.53985-1.61307,19.13656,21.79764,4.76014,21.9136-33.4044-2.23935-37.23467-4.57251S381.09716,730.79318,381.09716,730.79318Z",
    transform: "translate(-65.70844 -125.85228)",
    fill: "#a8a8a8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M423.22518,746.44314c-14.37642.116-33.40439-2.23933-37.23466-4.57251-2.91695-1.77683-4.07933-8.15253-4.46825-11.094-.26935.01158-.42511.01657-.42511.01657s.80653,10.26991,4.63681,12.60309,22.85824,4.6885,37.23466,4.5725c4.1499-.03347,5.58335-1.50994,5.50464-3.69673C427.89675,745.59323,426.314,746.41824,423.22518,746.44314Z",
    transform: "translate(-65.70844 -125.85228)",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawHire);
export default __webpack_public_path__ + "static/media/undraw_hire.8e4241917c7692bcbeaead02f06d00d8.svg";
export { ForwardRef as ReactComponent };